'use strict';

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RP1 Date Picker jQuery plugin
 *
 * @author Roman Kelemen <roman.kelemen@racingpost.com>
 */
(function ($, moment, _, breakpoints) {
    'use strict';

    /**
     * Default configuration options
     * @type {Object}
     */

    var defaults = {
        date: null,
        minDate: null,
        maxDate: null,
        monthPickerAutoClose: false,
        monthAutoPick: false,
        initFromMonthPicker: false,
        weekStart: 1,
        autoOpen: false,
        autoClose: false,
        track: false,
        template: '',
        zIndex: 1000,
        container: null,
        placement: 'body',
        triggers: {
            today: 'ui-datePicker__calendar__btnToday',
            date: 'ui-datePicker__item_day',
            month: 'ui-datePicker__item_month',
            year: 'ui-datePicker__item_year',
            nextMonth: 'ui-datePicker__stepSelect__right',
            prevMonth: 'ui-datePicker__stepSelect__left',
            nextYears: 'ui-datePicker__stepper__right',
            prevYears: 'ui-datePicker__stepper__left',
            pickMonth: 'ui-datePicker__stepSelect__central',
            pickDate: 'ui-datePicker__backBlock',
            selectMonth: 'ui-datePicker__backSection__btnSelect',
            close: 'ui-datePicker__closeBlock'
        },
        css: {
            picker: 'ui-datePicker',
            pickerInline: 'ui-datePicker_inline',
            pointer: 'ui-datePicker__pointer',
            pointerInvert: 'ui-datePicker__pointer_top',
            datePicker: 'ui-datePicker__frontSection',
            monthPicker: 'ui-datePicker__backSection',
            dateDisabled: 'ui-datePicker__item_disabled',
            dateSelected: 'ui-datePicker__item_active',
            datePast: 'ui-datePicker__item_inactive',
            dateFuture: 'ui-datePicker__item_inactive',
            stepDisabled: 'ui-btn_secondary--disabled',
            monthSelected: 'ui-datePicker__item_active',
            monthDisabled: 'ui-datePicker__item_disabled',
            yearSelected: 'ui-datePicker__item_active',
            yearDisabled: 'ui-datePicker__item_disabled'
        },
        position: {
            my: 'center top+8',
            at: 'center bottom',
            collision: 'flipfit'
        },
        pointerPosition: {
            my: 'center-12 top',
            at: 'center bottom'
        }
    };

    /**
     * Default template
     *
     * @type {string}
     */
    var template = '\
        <div class="ui-datePicker__pointer"></div>\
        <div class="ui-datePicker__closeBlock ui-btn ui-btn_tiertiary">\
            <svg class="ui-datePicker__close ui-icon ui-icon_sizeMedium">\
                <use xlink:href="img/icons.svg#icon-cross"/>\
            </svg>\
        </div>\
        <div class="ui-datePicker__frontSection">\
            <div class="ui-datePicker__header ui-datePicker__header_calendar">\
                <span class="ui-datePicker__caption">Select Date</span>\
            </div>\
            <div class="ui-datePicker__calendar">\
                <div class="ui-datePicker__stepSelect ui-btnGroup">\
                    <a href="#" class="ui-datePicker__stepSelect__left ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthLeft">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-left"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__central ui-btn ui-btn_tiertiary" data-test-selector="link-calendarGoToMonthYear" >\
                        <span><%=viewDate.format("MMMM YYYY") %></span>\
                        <svg class="ui-icon ui-icon_sizeMedium ui-datePicker__centralIcon">\
                            <use xlink:href="img/icons.svg#icon-down"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__right ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthRight">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-right"/>\
                        </svg>\
                    </a>\
                </div>\
                <div class="ui-datePicker__calendar__footer">\
                    <div class="ui-datePicker__calendar__btnToday ui-btn ui-btn_primary" data-test-selector="link-calendarToday">Today</div>\
                </div>\
                <table class="ui-datePicker__calendar__block">\
                    <thead>\
                        <tr>\
                            <% for(var i = 0; i < week.length; i++) { %>\
                            <td class="ui-datePicker__calendar__cell"><%=week[i] %></td>\
                            <% } %>\
                        </tr>\
                    </thead>\
                    <tbody class="ui-datePicker__calendar__body">\
                        <% for(var i = 0; i < dates.length; i++) { %>\
                        <tr class="ui-datePicker__row">\
                            <% for(var j = 0; j < 7; j++) { %>\
                            <td class="ui-datePicker__cell">\
                                <a href="#" class="ui-datePicker__item ui-datePicker__item_day <%=dates[i][j].classes.join(" ") %>" data-date="<%=dates[i][j].data %>" data-test-selector="link-calendarDate"><%=dates[i][j].label %></a>\
                            </td>\
                            <% } %>\
                        </tr>\
                        <% } %>\
                    </tbody>\
                </table>\
            </div>\
        </div>\
        <div class="ui-datePicker__backSection">\
            <div class="ui-datePicker__header">\
                <div class="ui-datePicker__backBlock ui-btn ui-btn_tiertiary">\
                    <svg class="ui-datePicker__back ui-icon ui-icon_sizeMedium">\
                        <use xlink:href="img/icons.svg#icon-left"/>\
                    </svg>\
                </div>\
                <span class="ui-datePicker__caption">Choose Month</span>\
            </div>\
            <div class="ui-datePicker__months">\
                <table class="ui-datePicker__months__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                        <% for(var j = 0; j < 6; j++) { %>\
                        <td class="ui-datePicker__cell ui-datePicker__months__cell">\
                            <a href="#" class="ui-datePicker__item ui-datePicker__item_month <%= months[i][j].classes.join(" ") %>" data-month="<%= months[i][j].data %>" data-test-selector="link-calendarMonthSelect"><%= months[i][j].label %></a>\
                        </td>\
                        <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
            </div>\
            <div class="ui-datePicker__header ui-datePicker__header_years">\
                <span class="ui-datePicker__caption">Choose Year</span>\
            </div>\
            <div class="ui-datePicker__years">\
                <table class="ui-datePicker__years__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                    <% for(var j = 0; j < 3; j++) { %>\
                    <td class="ui-datePicker__cell ui-datePicker__years__cell">\
                    <a href="#" class="ui-datePicker__item ui-datePicker__item_year <%= years[i][j].classes.join(" ") %>" data-year="<%= years[i][j].data %>" data-test-selector="link-calendarYearSelect"><%= years[i][j].label %></a>\
                    </td>\
                    <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
                <div class="ui-datePicker__years__footer">\
                    <div class="ui-datePicker__stepper ui-btnGroup">\
                        <a href="#" class="ui-datePicker__stepper__left ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthLeft">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-left"/>\
                            </svg>\
                        </a>\
                        <a href="#" class="ui-datePicker__stepper__right ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthRight">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-right"/>\
                            </svg>\
                        </a>\
                    </div>\
                    <div class="ui-datePicker__backSection__btnSelect ui-btn ui-btn_primary" data-test-selector="link-calendarYearMonthSelect">Select</div>\
                </div>\
            </div>\
        </div>';

    /**
     * Plugin name
     *
     * @type {string}
     */
    var pluginName = 'datePicker';

    /**
     * Plugin constructor
     *
     * @param {HTMLElement|jQuery} element Bound element
     * @param {Object} options Instance configuration
     *
     * @constructor
     */
    function DatePicker(element, options) {
        this.element = $(element);
        this.options = $.extend(true, {}, defaults, options);
        this.options.css = $.extend({}, defaults.css, $.fn[pluginName].css, options ? options.css : {});
        this.options.triggers = $.extend({}, defaults.triggers, $.fn[pluginName].triggers, options ? options.triggers : {});

        this._container = null;
        if (this.options.container) {
            this._container = $(this.options.container);
        }

        this._minDate = null;
        if (this.options.minDate) {
            this._minDate = moment(this.options.minDate).startOf('day');
        }

        this._maxDate = null;
        if (this.options.maxDate) {
            var maxDate = moment(this.options.maxDate);
            if (!this._minDate || maxDate.subtract(1, 'day').isAfter(this._minDate)) {
                this._maxDate = moment(this.options.maxDate).endOf('day');
            }
        }

        this._date = null;
        if (this.options.date && this.isValid(this.options.date)) {
            this._date = moment(this.options.date);
        }

        if (this._date) {
            this.currentDate(this._date, true);
        } else {
            this.currentDate(moment(), true);
        }

        this._monthPicker = this.options.initFromMonthPicker === true;
        this._monthPickerDate = this.currentDate();
        this._yearsPage = undefined;

        this.saveState();

        this.picker = $('<div class="' + this.options.css.picker + '"></div>');
        this.picker.hide().css('z-index', this.options.zIndex);

        if (this._container) {
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        } else {
            this.picker.appendTo(this.options.placement);
        }

        this.breakpoints = breakpoints;
        this.breakpoint = this.breakpoints.current();

        this.init();
    }

    /**
     * Save datepicker state
     */
    DatePicker.prototype.saveState = function () {
        this._initial = {
            date: this.date(),
            current: this.currentDate(),
            minDate: this.minDate(),
            maxDate: this.maxDate()
        };
    };

    /**
     * Reset to initial state
     */
    DatePicker.prototype.restoreState = function () {
        this._minDate = this._initial.minDate;
        this._maxDate = this._initial.maxDate;
        this._currentDate = this._initial.current;
        this._date = this._initial.date;

        this.element.trigger('restoreState.rp.datePicker');
        this.render(true);
    };

    /**
     * Initialise basic functionality
     */
    DatePicker.prototype.init = function () {
        this.bindEvents();
        this.render();
        if (this.options.autoOpen) {
            this.show();
        }
    };

    /**
     * Destroy plugin instance. Unbind events, remove DOM
     */
    DatePicker.prototype.destroy = function () {
        this.picker.remove();
        this.element.off('.rp.datePicker');
        $('body').off('.rp.datePicker');
        $.data(this.element, pluginName, null);
    };

    /**
     * Get or set minimum date
     *
     * @param {Moment|String=} minDate Optionally, set minimum date.
     * @returns {Moment|null|void} If argument ommited, returns current minimum date
     */
    DatePicker.prototype.minDate = function (minDate) {
        if (minDate === undefined) {
            return this._minDate ? moment(this._minDate) : null;
        }

        minDate = moment(minDate);
        if (!minDate.isAfter(moment(this._maxDate), 'day')) {
            this._minDate = minDate.startOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Get or set maximum date
     *
     * @param {Moment|String=} maxDate Optionally, set maximum date.
     * @returns {Moment|null|void} If argument ommited, returns current maximum date
     */
    DatePicker.prototype.maxDate = function (maxDate) {
        if (maxDate === undefined) {
            return this._maxDate ? moment(this._maxDate) : null;
        }

        maxDate = moment(maxDate);
        if (!maxDate.isBefore(moment(this._minDate), 'day')) {
            this._maxDate = maxDate.endOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Checks, if given date is valid
     *
     * @param {Moment|String} date Date to check
     * @returns {boolean} TRUE if date is valid, FALSE otherwise
     */
    DatePicker.prototype.isValid = function (date) {
        var check = moment(date);

        if (this._minDate && this._maxDate) {
            return this._minDate <= check && this._maxDate >= check;
        } else if (this._maxDate) {
            return this._maxDate >= check;
        } else if (this._minDate) {
            return this._minDate <= check;
        }

        return true;
    };

    /**
     * Bind handlers to handle required events
     */
    DatePicker.prototype.bindEvents = function () {
        this.picker.on('click', '.' + this.options.triggers.today, { context: this }, this.today);
        this.picker.on('click', '.' + this.options.triggers.date + ':not(.disabled)', { context: this }, this.date);
        this.picker.on('click', '.' + this.options.triggers.month, { context: this }, this.month);
        this.picker.on('click', '.' + this.options.triggers.year, { context: this }, this.year);
        this.picker.on('click', '.' + this.options.triggers.nextMonth + ':not(.disabled)', { context: this }, this.nextMonth);
        this.picker.on('click', '.' + this.options.triggers.prevMonth + ':not(.disabled)', { context: this }, this.prevMonth);
        this.picker.on('click', '.' + this.options.triggers.nextYears, { context: this }, this.nextYears);
        this.picker.on('click', '.' + this.options.triggers.prevYears, { context: this }, this.prevYears);
        this.picker.on('click', '.' + this.options.triggers.pickMonth, { context: this }, this.pickMonth);
        this.picker.on('click', '.' + this.options.triggers.pickDate, { context: this }, this.pickDate);
        this.picker.on('click', '.' + this.options.triggers.selectMonth, { context: this }, this.selectMonth);
        this.picker.on('click', '.' + this.options.triggers.close, { context: this }, this.hide);

        this.element.on('click.rp.datePicker', { context: this }, this.toggle);

        $(window).on('resize.rp.datePicker', this._onWindowResize());
        $(window).on('scroll.rp.datePicker', _lodash2.default.throttle(this.position.bind(this), 50));
        $(window).on('rpBreakpointsSwitch', this._onBreakpoint());
        $('body').on('click', { context: this }, function (event) {
            var skip = event.originalEvent && event.originalEvent.keepShown === event.data.context || $(event.target).is(event.data.context.element) || $.contains(event.data.context.picker[0], event.target) || $.contains(event.data.context.element[0], event.target);
            if (skip) {
                return;
            }

            event.data.context.hide();
        });
    };

    /**
     * Open picker if it is hidden, or hide it, if it is opened
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, Event object
     */
    DatePicker.prototype.toggle = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.data.context.toggle();
            return;
        }

        if (this.picker.is(':visible')) {
            this.hide();
        } else {
            this.show();
        }
    };

    /**
     * Open picker
     */
    DatePicker.prototype.show = function () {
        var event = $.Event('show.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented()) {
            if (this._container && !this._container.is(this.picker.parent())) {
                this._container.append(this.picker);
            }

            this.picker.show();
            this.position();
            this.element.trigger('shown.rp.datePicker');
        }
    };

    /**
     * Hide picker
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, event object
     */
    DatePicker.prototype.hide = function (event) {
        if (event && event.preventDefault) {
            if ($(event.data.context.picker).is(':visible') && !event.data.context._container) {
                event.preventDefault();
                event.data.context.hide();
            }

            return;
        }

        event = $.Event('hide.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented() && this.picker.is(':visible')) {
            this.picker.hide();
            this.element.trigger('hidden.rp.datePicker');
        }
    };

    /**
     * Set selected and view date to today
     * If called as event handler, event object passed as first argument.
     *
     * @param event Optionally, event object
     */
    DatePicker.prototype.today = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.today();
            return;
        }

        var today = moment();

        this.currentDate(today);
        this.date(today, this.options.autoClose);
    };

    /**
     * Get or set selected date
     *
     * @param {Moment|String|null|Event=} date Optionally. If called as event, this is event object.
     * If called directly, this param should contain date to select
     * @param {Boolean=} close Optionally. Close auto picker after success change
     *
     * @return {Moment|void} If called without parameters, method will return currently selected date
     */
    DatePicker.prototype.date = function (date, close) {
        if (date === undefined) {
            return this._date ? moment(this._date) : null;
        }

        if (date.data && date.data.context) {
            date.preventDefault();
            date.originalEvent.keepShown = date.data.context;
            date.data.context.date($(this).data('date'), date.data.context.options.autoClose);
            return;
        }

        if (this.isValid(date)) {
            var oldDate = this.date(),
                newDate = moment(date),
                event = $.Event('change.rp.datePicker');

            this.element.trigger(event, [newDate, oldDate]);

            if (!event.isDefaultPrevented()) {
                this._date = moment(date);
                this._currentDate = moment(this._date);

                if (close) {
                    this.hide();
                }

                this.render();
            }
        }
    };

    /**
     * Deselect selected date
     */
    DatePicker.prototype.reset = function () {
        var oldDate = this.date();
        this._date = null;
        this.element.trigger('reset.rp.datePicker', [oldDate]);

        this.render();
    };

    /**
     * Set current (view) date
     *
     * @param {Moment|String=} date Date to view
     * @param {Boolean=} noRender Optionally, picker after changing view date. Default is false, that means that
     * picker will be re-rendered automatically
     */
    DatePicker.prototype.currentDate = function (date, noRender) {
        if (!date) {
            return moment(this._currentDate);
        } else {
            date = moment(date);

            if (this._minDate) {
                date = moment.max(date, this._minDate);
            }

            if (this._maxDate) {
                date = moment.min(date, this._maxDate);
            }

            this._yearsPage = undefined;
            this._currentDate = date;
            if (!noRender) {
                this.render();
            }
        }
    };

    /**
     * Get or set view month
     *
     * @param {Moment|String|Event=} month Optionally. If called as event, this is event object.
     * If called directly, this param should contain zero-based index of month to view
     *
     * @return {Number|void} If called without parameters, method will return current view month as zero-based number
     */
    DatePicker.prototype.month = function (month) {
        if (month === undefined) {
            return this._currentDate.month();
        }

        if (month.data && month.data.context) {
            month.preventDefault();
            month.data.context.month($(this).data('month'));
            month.originalEvent.keepShown = month.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).month(month);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Get or set view year
     *
     * @param {Moment|String|Event=} year Optionally. If called as event, this is event object.
     * If called directly, this param should contain view year
     *
     * @return {Number|void} If called without parameters, method will return current view year
     */
    DatePicker.prototype.year = function (year) {
        if (year === undefined) {
            return this._currentDate.year();
        }

        if (year.data && year.data.context) {
            year.preventDefault();
            year.data.context.year($(this).data('year'));
            year.originalEvent.keepShown = year.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).year(year);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Go to next years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextYears();
            return;
        }

        if (this._maxDate && this._yearsPage >= this._getYearPage(this._maxDate.year())) {
            this._yearsPage = this._getYearPage(this._maxDate.year());
        } else {
            this._yearsPage++;
        }

        this.render();
    };

    /**
     * Go to previous years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevYears();
            return;
        }

        if (this._minDate && this._yearsPage <= this._getYearPage(this._minDate.year())) {
            this._yearsPage = this._getYearPage(this._minDate.year());
        } else {
            this._yearsPage--;
        }

        this.render();
    };

    /**
     * Go to next month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextMonth();
            return;
        }

        this.currentDate(this.currentDate().add(1, 'month'));
    };

    /**
     * Go to previous month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevMonth();
            return;
        }

        this.currentDate(this.currentDate().subtract(1, 'month'));
    };

    /**
     * Open month picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickMonth();
            return;
        }

        this._yearsPage = undefined;
        this._monthPicker = true;
        this._monthPickerDate = this.currentDate();
        this.render();
    };

    /**
     * Open date picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickDate = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickDate();
            return;
        }

        this._monthPicker = false;
        if (!this.options.monthPickerAutoClose && !this.options.monthAutoPick) {
            this.currentDate(this._monthPickerDate);
        }

        this.render();
    };

    /**
     * Select month and close month picker
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.selectMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.selectMonth();
            return;
        }

        this._monthPicker = false;
        this.render();
    };

    /**
     * Render date picker
     * @param {Boolean=} force Optionally, force render
     */
    DatePicker.prototype.render = function (force) {
        var self = this;
        var tpl = this.options.template ? this.options.template : $.fn[pluginName].template ? $.fn[pluginName].template : template;

        var compiled = _.template(tpl),
            renderHtml = function renderHtml() {
            self.picker.html(compiled({
                dates: self.buildDates(),
                months: self.buildMonths(),
                years: self.buildYears(),
                week: self.buildWeek(),
                viewDate: self.currentDate()
            }));

            self.picker.data('currentDate', self.currentDate());
            self.picker.data('yearsPage', self._yearsPage);

            self.position();
        },
            updateMonthView = function updateMonthView() {
            var datePicker, monthPicker;

            datePicker = self.picker.find('.' + self.options.css.datePicker);
            monthPicker = self.picker.find('.' + self.options.css.monthPicker);
            if (self._monthPicker) {
                monthPicker.show();
                datePicker.hide();
            } else {
                monthPicker.hide();
                datePicker.show();
            }
        },
            updateMonthStep = function updateMonthStep() {
            if (!self.isValid(self.currentDate().add(1, 'month').startOf('month'))) {
                self.picker.find('.' + self.options.triggers.nextMonth).addClass(self.options.css.stepDisabled);
            }

            if (!self.isValid(self.currentDate().subtract(1, 'month').endOf('month'))) {
                self.picker.find('.' + self.options.triggers.prevMonth).addClass(self.options.css.stepDisabled);
            }
        },
            updateYearStep = function updateYearStep() {
            var prevYears = self.picker.find('.' + self.options.triggers.prevYears),
                nextYears = self.picker.find('.' + self.options.triggers.nextYears);

            prevYears.removeClass(self.options.css.stepDisabled);
            nextYears.removeClass(self.options.css.stepDisabled);

            if (self._minDate && self._yearsPage <= self._getYearPage(self._minDate.year())) {
                self._yearsPage = self._getYearPage(self._minDate.year());
                prevYears.addClass(self.options.css.stepDisabled);
            }

            if (self._maxDate && self._yearsPage >= self._getYearPage(self._maxDate.year())) {
                self._yearsPage = self._getYearPage(self._maxDate.year());
                nextYears.addClass(self.options.css.stepDisabled);
            }
        };

        renderHtml();
        updateMonthView();
        updateMonthStep();
        updateYearStep();
    };

    /**
     * Build months matrix
     * @returns {Array} Matrix of months
     */
    DatePicker.prototype.buildMonths = function () {
        var months = moment.monthsShort(),
            selectedMonth = this.currentDate().format('MMM'),
            rows = [],
            row,
            month;

        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 6; j++) {
                var key = 6 * i + j;
                month = {
                    data: key,
                    label: months[key],
                    classes: []
                };
                var check = this.currentDate().month(key);

                if (this._minDate && this._minDate.isAfter(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (this._maxDate && this._maxDate.isBefore(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (months[key] == selectedMonth) {
                    month.classes.push(this.options.css.monthSelected);
                }

                row.push(month);
            }
            rows.push(row);
        }

        return rows;
    };

    /**
     * Build years matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildYears = function () {
        var current = this.currentDate(),
            view = moment(),
            rows = [],
            offset,
            row;

        if (this._yearsPage === undefined) {
            this._yearsPage = this._getYearPage();
        }

        offset = this._yearsPage * 6 - 3;
        view.add(offset, 'year');
        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 3; j++) {
                var year = {
                    data: view.year(),
                    label: view.format('YYYY'),
                    classes: []
                };

                if (this._minDate && this._minDate.year() > view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (this._maxDate && this._maxDate.year() < view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (view.year() == current.year()) {
                    year.classes.push(this.options.css.yearSelected);
                }

                row.push(year);
                view.add(1, 'year');
            }

            rows.push(row);
        }

        return rows;
    };

    /**
     * Calculate years page
     *
     * @returns {Number} page of current viewed year
     */
    DatePicker.prototype._getYearPage = function (year) {
        year = year ? year : this.currentDate().year();

        var diff = year - moment().year() - 2;
        return Math.ceil(diff / 6);
    };

    /**
     * Build days matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildDates = function () {
        var css = this.options.css,
            current = this.currentDate(),
            origin = this.currentDate(),
            selected = this.date(),
            days = current.daysInMonth(),
            offset = current.startOf('month').day() - this.options.weekStart,
            rows,
            dates,
            date;

        offset = offset < 0 ? 6 : offset;

        current.subtract(offset, 'days');
        rows = [];
        for (var i = 0, lines = Math.ceil((days + offset) / 7); i < lines; i++) {
            dates = [];
            for (var j = 0; j < 7; j++) {
                date = {
                    data: current.format('YYYY-MM-DD'),
                    label: current.format('D'),
                    moment: moment(current),
                    classes: []
                };

                if (!this.isValid(current)) {
                    date.classes.push(css.dateDisabled);
                } else if (current.isSame(selected, 'day')) {
                    date.classes.push(css.dateSelected);
                }

                if (i === 0 && j < offset) {
                    date.classes.push(css.datePast);
                } else if (current.month() != origin.month()) {
                    date.classes.push(css.dateFuture);
                }

                dates.push(date);
                current.add(1, 'days');
            }
            rows.push(dates);
        }

        return rows;
    };

    /**
     * Build week days array
     * @returns {Array} Array of week days abbreviations
     */
    DatePicker.prototype.buildWeek = function () {
        var weekDays = moment.weekdaysMin();
        if (this.options.weekStart) {
            weekDays = weekDays.concat(weekDays.splice(0, this.options.weekStart));
        }

        return weekDays;
    };

    /**
     * Place datePicker in configured position
     */
    DatePicker.prototype.position = function () {
        var position = this.options.position,
            track = this.options.track,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop,
            pointerPosition = this.options.pointerPosition,
            pointer = this.picker.find('.' + this.options.css.pointer);

        if (!position.of) {
            position.of = this.element;
        }

        if (!pointerPosition.of) {
            pointerPosition.of = position.of;
        }

        var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
            EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;

        var wideScreen = [NARROW, EXTRA_NARROW].indexOf(this.breakpoint.code) === -1;

        if (wideScreen && !this._container) {
            this.picker.position(position);
            pointer.position(pointerPosition);
            pointer.css('top', 0);
            if (this.picker.offset().top < this.element.offset().top) {
                pointer.addClass(this.options.css.pointerInvert);
            } else {
                pointer.removeClass(this.options.css.pointerInvert);
            }
        } else {
            if (track) {
                this.picker.css('top', scrollTop).css('left', '');
            } else {
                this.picker.css('top', '').css('left', '');
            }
        }
    };

    /**
     * Change container of datepicker
     */
    DatePicker.prototype.container = function (selector) {
        if (!selector) {
            this._container = null;
            this.picker.removeClass(this.options.css.pickerInline);
            this.picker.appendTo(this.options.placement);
        } else {
            this._container = $(selector);
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        }

        this.position();
    };

    /**
     * Window resize event handler
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onWindowResize = function () {
        var self = this,
            tm = null;

        return function () {
            clearTimeout(tm);

            tm = setTimeout(function () {
                self.position();
            }, 100);
        };
    };

    /**
     * Breakpoint change event
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onBreakpoint = function () {
        var self = this;

        return function (event) {
            self.breakpoint = event.detail.breakpoint;
        };
    };

    /**
     * Register plugin function
     *
     * @param params
     * @returns {$.fn}
     */
    $.fn[pluginName] = function (params) {
        var args = Array.prototype.slice.call(arguments, 1);
        var getterResult;

        this.each(function () {
            var object = $.data(this, pluginName);
            if (!object) {
                $.data(this, pluginName, new DatePicker(this, params));
            } else if (params && params != '_' && object[params]) {
                getterResult = object[params].apply(object, args);
            } else {
                object.show();
            }
        });

        return getterResult !== undefined ? getterResult : this;
    };

    /**
     * Global CSS styles
     * @type {Object}
     */
    $.fn[pluginName].css = {};

    /**
     * Global triggers
     * @type {Object}
     */
    $.fn[pluginName].triggers = {};

    /**
     * Global template
     * @type {Object}
     */
    $.fn[pluginName].template = '';
})(_jquery2.default, _moment2.default, _lodash2.default, _rpMqBreakpoints2.default);


//////////////////
// WEBPACK FOOTER
// ./~/datepicker/lib/datePicker.js
// module id = 1634
// module chunks = 0